import { render, staticRenderFns } from "./SummaryVdpTables.vue?vue&type=template&id=5822f5ce&scoped=true&"
import script from "./SummaryVdpTables.vue?vue&type=script&lang=js&"
export * from "./SummaryVdpTables.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVdpTables.vue?vue&type=style&index=0&id=5822f5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822f5ce",
  null
  
)

export default component.exports